import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { ChangeEvent, MouseEvent, useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { CreatePointAchieveType } from '@/types';
import { createPointAchieve } from '@/api/point/create';
import { toast } from 'react-toastify';
import { sleep } from '@/lib/util';
import Loading from '@/component/mui/Backdrop';

export default function RegisterAchieve({
  settingId,
  onSuccess,
  refresh,
}: {
  settingId: string;
  onSuccess: () => void;
  refresh: number;
}) {
  const defaultItem: CreatePointAchieveType = {
    settingId: settingId,
    title: '',
    describe: '',
    amount: '',
    requireValue: '',
    conditionType: 0,
    isActive: 1,
  };
  const [item, setItem] = useState<CreatePointAchieveType>(defaultItem);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setItem(defaultItem);
      // await readSettingAcumulatedList();
    })();
    return () => {};
  }, [refresh]);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (!name) {
      return;
    }
    setItem((prev: CreatePointAchieveType) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (!item.amount || !item.requireValue) {
      toast.error('수량을 넣어 주세요.');
      return;
    }
    if (!item.title) {
      toast.error('제목을 넣어 주세요.');
      return;
    }

    setIsLoading(true);
    try {
      const re = await createPointAchieve(item);
      if (re.status !== 200) {
        toast.error('실패');
        setIsLoading(false);
        return;
      }
      await sleep(1000);
      toast.success('성공');
      setIsLoading(false);
      onSuccess();
    } catch (e) {
      toast.error('실패');
      setIsLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h6">추가 포인트 생성</Typography>
      <Box p={1} />
      <Grid container spacing={3}>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>amount</InputLabel>
            <OutlinedInput
              type="string"
              value={item.amount}
              label="amount"
              name="amount"
              onChange={handleChangeValue}
            />
            <FormHelperText>※ 사용자가 받는 포인트</FormHelperText>
          </FormControl>
        </Grid>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Title</InputLabel>
            <OutlinedInput value={item.title} label="title" name="title" onChange={handleChangeValue} />
          </FormControl>
        </Grid>
      </Grid>
      <Box mb={2} />
      <TextField
        name="describe"
        id="describe"
        label="describe"
        multiline
        rows={1}
        value={item.describe}
        onChange={handleChangeValue}
      />
      <FormHelperText>※ 설명</FormHelperText>

      <Box mb={2} />
      <Grid container spacing={3}>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>목표 포인트</InputLabel>
            <OutlinedInput
              type="string"
              value={item.requireValue}
              label="requireValue"
              name="requireValue"
              onChange={handleChangeValue}
            />
            <FormHelperText>※ 목표 포인트(목표 포인트에 달성해야 사용자에게 amount 지급)</FormHelperText>
          </FormControl>
        </Grid>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <RadioGroup
              row
              name="radio-button"
              aria-labelledby="group-type"
              value={item.isActive}
              onChange={handleChangeValue}
            >
              <FormControlLabel value="0" control={<Radio />} label="비활성화" />
              <FormControlLabel value="1" control={<Radio />} label="활성화" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Box mb={5} />
      <Button fullWidth variant="contained" onClick={onSubmit}>
        생성
      </Button>
      <Loading isLoading={isLoading} />
    </>
  );
}
